// src/pages/AboutUs.tsx
import React from "react";
import AboutImg from "../assets/images/About.jpg"; // adjust relative path


const AboutUs: React.FC = () => {
  return (
    <div
      style={{
        padding: "4rem 2rem",
        maxWidth: "1000px",
        margin: "0 auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#444",
        lineHeight: 1.6,
      }}
    >
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${AboutImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          padding: "6rem 2rem",
          color: "#fff",
          textAlign: "center",
          marginBottom: "3rem",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: 700,
            marginBottom: "1rem",
            color: "#FFD700", // gold
            textShadow: "2px 2px 8px rgba(0,0,0,0.6)",
          }}
        >
          About Us
        </h1>
        <p
  style={{
    fontSize: "1.25rem",
    maxWidth: "800px",
    margin: "0 auto",
    color: "#FFF5E1", // warm soft tone
    textShadow: "1px 1px 6px rgba(0,0,0,0.6)",
    lineHeight: "1.8",
    textAlign: "justify",
    padding: "1.5rem",
    background: "rgba(0,0,0,0.4)", // semi-transparent background for readability
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    fontWeight: 400,
  }}
>
  <span
    style={{
      fontSize: "2rem",
      fontWeight: "bold",
      color: "#FFD700", // golden highlight
      float: "left",
      marginRight: "10px",
      lineHeight: "1",
    }}
  >
    T
  </span>
  he Destinations Dreams Travel Agency Affiliated business by the Leading
  Universe Prospects located at Muscat, Sultanate of Oman. We are a member of
  the following government organization: Muscat Municipality Sultanate of Oman
  and Ministry of Heritage and Tourism. We are also a Member of Oman Chamber of
  Commerce Industry. We partner with local tour operators in Oman and
  International travel operators. The Destinations Dreams Travel Agency was
  founded in 2019 as a Sole Proprietorship owned and operated by an experienced
  in commanding the different nationalities concentrating on FIT (Free
  Independent Travelers) and GIT (Group Inclusive Tours). We remain committed to
  our principles of giving individual and personalized services to each Clients.
</p>

      </div>

      {/* Content Section */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem" }}>
        <div style={{ flex: "1 1 450px" }}>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 600,
              marginBottom: "1rem",
              color: "#E1306C", // pink/red accent
            }}
          >
            Who We Are
          </h2>
          <p style={{ color: "#333" }}>
            Destination Dreams is your trusted travel partner, dedicated to
            creating unforgettable journeys for every traveler. Whether you’re
            seeking serene beaches, cultural explorations, or adventurous treks,
            we design experiences that stay with you forever.
          </p>
        </div>

        <div style={{ flex: "1 1 450px" }}>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 600,
              marginBottom: "1rem",
              color: "#FF7F50", // coral
            }}
          >
            Our Mission
          </h2>
          <p style={{ color: "#444" }}>
            The Destinations Dreams Travel Agency is committed to provide our
            clients with excellent products and services covering all aspects of
            your travel needs tailored to your choice at an affordable price for
            your utmost satisfaction.
          </p>
        </div>

        <div style={{ flex: "1 1 450px" }}>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 600,
              marginBottom: "1rem",
              color: "#1E90FF", // dodger blue
            }}
          >
            Our Vision
          </h2>
          <p style={{ color: "#444" }}>
            Our vision is to uphold the highest standards in servicing our
            Clients with honesty, efficiency, and promptness.
          </p>
        </div>

        <div style={{ flex: "1 1 450px" }}>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 600,
              marginBottom: "1rem",
              color: "#32CD32", // lime green
            }}
          >
            Why Choose Us
          </h2>
          <ul
            style={{
              paddingLeft: "1.2rem",
              marginTop: 0,
              color: "#333",
            }}
          >
            <li>Tailor-made travel packages</li>
            <li>Expert travel consultants</li>
            <li>Competitive prices and offers</li>
            <li>24/7 support and guidance</li>
            <li>Focus on safe and memorable experiences</li>
          </ul>
        </div>
      </div>

      {/* Call-to-action */}
      <div style={{ textAlign: "center", marginTop: "3rem" }}>
        <p
          style={{
            fontSize: "1.1rem",
            marginBottom: "1rem",
            color: "#E1306C", // pink/red
            fontWeight: "bold",
          }}
        >
          Ready to plan your dream trip?
        </p>
        <a
          href="/contact-us"
          style={{
            padding: "0.8rem 2rem",
            backgroundColor: "#E1306C",
            color: "#fff",
            borderRadius: "6px",
            textDecoration: "none",
            fontWeight: "bold",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.3s, background 0.3s",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.backgroundColor = "#C2185B";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.backgroundColor = "#E1306C";
          }}
        >
          Contact Us
        </a>
      </div>
    </div>
  );
};

export default AboutUs;
